import React from 'react';
import { Line } from 'react-chartjs-2';

const CommodityChart = () => {
  const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    datasets: [
      {
        label: 'Containerized',
        data: [78420, 72150, 81230, 79850, 83140, 85420],
        borderColor: '#4da6ff',
        backgroundColor: 'rgba(77, 166, 255, 0.1)',
        borderWidth: 3,
        tension: 0.4,
        fill: true
      },
      {
        label: 'Dry Bulk',
        data: [58240, 55760, 60120, 57890, 59840, 62150],
        borderColor: '#ff9f40',
        backgroundColor: 'rgba(255, 159, 64, 0.1)',
        borderWidth: 3,
        tension: 0.4,
        fill: true
      },
      {
        label: 'Liquid Bulk',
        data: [30150, 28760, 29430, 27980, 29450, 28360],
        borderColor: '#ff6384',
        backgroundColor: 'rgba(255, 99, 132, 0.1)',
        borderWidth: 3,
        tension: 0.4,
        fill: true
      },
      {
        label: 'Break Bulk',
        data: [8240, 8750, 9120, 8960, 9310, 9500],
        borderColor: '#4cd964',
        backgroundColor: 'rgba(76, 217, 100, 0.1)',
        borderWidth: 3,
        tension: 0.4,
        fill: true
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: false,
        title: {
          display: true,
          text: 'Tons'
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        }
      },
      x: {
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        }
      }
    },
    plugins: {
      legend: {
        position: 'top',
      }
    }
  };

  return <Line data={data} options={options} />;
};

export default CommodityChart;